import i18n from '@/i18n';
import utilities from './utilities';
import constants from './constants';

export default {

    biggerThanZero: [
        v => !v || utilities.isNumeric(v) || i18n.t('message.validation.numeric'),
        v => !v || Number(v.toString().replace(',', '.')) > 0 || i18n.t('message.validation.notZero'),
    ],

    email: [
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || i18n.t('message.validation.invalid'),
    ],

    login: [
        v => !!v || i18n.t('message.validation.required'),
        v => !v || v.length >= 7 || i18n.t('message.validation.loginTooShort'),
    ],

    numeric: [
        v => !v || utilities.isNumeric(v) || i18n.t('message.validation.numeric'),
    ],

    password: [
        v => !!v || i18n.t('message.validation.required'),
        v => !v || v.length >= 6 || i18n.t('message.validation.passwordTooShort'),
    ],

    required: [v => !!v || i18n.t('message.validation.required')],

    requiredEmail: [
        v => !!v || i18n.t('message.validation.required'),
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || i18n.t('message.validation.invalid'),
    ],

    requiredNumeric: [
        v => !!v || i18n.t('message.validation.required'),
        v => utilities.isNumeric(v) || i18n.t('message.validation.numeric'),
    ],

    requiredBiggerThanZero: [
        v => !!v || i18n.t('message.validation.required'),
        v => utilities.isNumeric(v) || i18n.t('message.validation.numeric'),
        v => !v || Number(v.toString().replace(',', '.')) > 0 || i18n.t('message.validation.notZero'),
    ],

    text: [
        v => !!v || i18n.t('message.validation.required'),
        v => !v || v.length >= 3 || i18n.t('message.validation.tooShort'),
    ],

    mask: {
        contract: '######/##',
        daysToDelivery: utilities.padStart('', constants.LENGTH_DAYS_TO_DELIVERY, '#'),
        demandCode: utilities.padStart('', constants.LENGTH_DEMAND_CODE, '#'),
        estimatedTime: utilities.padStart('', constants.LENGTH_ESTIMATED_TIME, '#'),
        plannedTime: utilities.padStart('', constants.LENGTH_PLANNED_TIME, '#'),
        executedTime: utilities.padStart('', constants.LENGTH_EXECUTED_TIME, '#'),
        warrantyDays: utilities.padStart('', constants.LENGTH_CONTRACT_WARRANTY, '#'),
        unitCost: utilities.padStart('', constants.LENGTH_CONTRACT_UNIT_VALUE, '#'),
        hiredAmount: utilities.padStart('', constants.LENGTH_CONTRACT_HIRED_AMOUNT, '#'),
        timeAmount: utilities.padStart('', constants.LENGTH_CONTRACT_ITEM_QUANTITY, '#'),
    },

};



// WEBPACK FOOTER //
// ./src/helpers/validation.js